import React, { useState, useContext } from "react";

// Styles
import Button from "@material-ui/core/Button";
import FormHelperText from "@material-ui/core/FormHelperText";

//Component
//--> Input
import PhoneInput from "../../components/Input/PhoneInput";
import TextInput from "../../components/Input/TextInput";
//--> Alert
import { Warning } from "../../components/Alert/Alert";
//--> Footer
// import Footer from "../../components/Navigation/Footer";
//--> Counter Picker
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";

//Context
import { AuthActionContext } from "../../context/AuthContext";

export default function UserInfo() {
  const { userInfo } = useContext(AuthActionContext);

  const [phoneNumber, setPhoneNumber] = useState("");
  const [address, setAddress] = useState("");
  const [country, setCountry] = useState("Pakistan");
  const [region, setRegion] = useState("");
  const [warn, setWarn] = useState("");

  const selectCountry = (val) => {
    setCountry(val);
  };

  const selectRegion = (val) => {
    setRegion(val);
  };

  const handleInfo = () => {
    phoneNumber !== "" && country !== "" && region !== "" && address !== ""
      ? userInfo(phoneNumber, country, region, address, setWarn)
      : setWarn("Please fill all inputs!");
    setTimeout(() => {
      setWarn("");
    }, 10000);
  };

  return (
    <div>
      <div className="AuthScreen">
        <div className="AuthContainer">
          {warn ? (
            <Warning
              msg={warn}
              style={{ width: 350, padding: 20, margin: 20 }}
            />
          ) : null}
          <div className="AuthBox">
            <h1 className="AuthHeading">Complete Profile Information</h1>
            <h1 className="AuthSubHeading">Provide your details!</h1>
            <div className="flexCenter">
              <PhoneInput value={phoneNumber} onChangeEvent={setPhoneNumber} />
            </div>
            <div className="flexCenter">
              <div style={{ display: "flex", flexDirection: "row" }}>
                <CountryDropdown
                  style={{ marginRight: 5 }}
                  className="DropDown"
                  value={country}
                  onChange={(val) => selectCountry(val)}
                />
                <RegionDropdown
                  style={{ marginLeft: 5 }}
                  className="DropDown"
                  country={country}
                  value={region}
                  onChange={(val) => selectRegion(val)}
                />
              </div>
            </div>
            <div className="flexCenter">
              <TextInput
                label="Complete Address"
                multiline={true}
                size="small"
                value={address}
                onChangeEvent={setAddress}
              />
              <FormHelperText style={{ alignSelf: "flex-start" }}>
                Please write your complete address.
              </FormHelperText>
            </div>
            <div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <Button
                  fullWidth
                  variant="contained"
                  style={{
                    background: "linear-gradient(80deg, #0099ff, #005288)",
                    color: "#fff",
                    margin: "10px 0px",
                  }}
                  onClick={handleInfo}
                >
                  Proceed to Dashboard
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
